import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import { CHECK_ADDRESS_QUERY_KEY, CHECK_ADDRESS_URL } from './queryConstants'

type AddressCheck = {
  addressId: string
  residentId: string
}

export type AddressUsageCheck = {
  instances?: unknown[]
  patterns?: unknown[]
  revisions?: unknown[]
}

type UseCheckAddressReturn = {
  checkAddressUsedInRota: (values: AddressCheck) => Promise<AddressUsageCheck>
  isLoading: boolean
}

const useCheckAddress = (): UseCheckAddressReturn => {
  const createFunction = async (values: AddressCheck) => {
    return postJSON({
      url: CHECK_ADDRESS_URL,
      method: 'POST',
      json: values,
      isRota: true
    })
  }

  const { mutateAsync: createMutation, isLoading } = useMutation<
    AddressUsageCheck,
    unknown,
    AddressCheck,
    unknown
  >([CHECK_ADDRESS_QUERY_KEY], createFunction)

  const checkAddressUsedInRota = async (values: AddressCheck) => {
    try {
      const result = await createMutation(values)
      return result
    } catch (err) {
      // preserves the existing behaviour of returning the error itself rather than throwing
      return err as AddressUsageCheck
    }
  }

  return {
    checkAddressUsedInRota,
    isLoading
  }
}

export default useCheckAddress
